import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SessionTimerButton, ToggleNotesButton, ToggleParticipantsButton, ToggleSettingsButton } from 'components';
import { useRoomState, useRoomRightSidebar, useRoomHost } from 'hooks';

import styles from './SidebarControls.module.scss';

export function SidebarControls(): JSX.Element {
  const { t } = useTranslation('providerRoom');
  const roomState = useRoomState();
  const { isHost } = useRoomHost();
  const { toggleSettings, toggleNotes, toggleParticipants } = useRoomRightSidebar();
  const isReconnecting = roomState === 'reconnecting';

  return (
    <Stack className={styles.container} direction='row'>
      {isHost && (
        <Stack className={styles.controlWithLabel}>
          <SessionTimerButton />
          <Typography component='p' className={styles.controlLabel}>
            {t('aria.sessionTimer')}
          </Typography>
        </Stack>
      )}

      {isHost && (
        <Stack className={styles.controlWithLabel}>
          <ToggleNotesButton onClick={toggleNotes} withTooltip />
          <Typography component='p' className={styles.controlLabel}>
            {t('aria.notes')}
          </Typography>
        </Stack>
      )}

      <Stack className={styles.controlWithLabel}>
        <ToggleParticipantsButton onClick={toggleParticipants} withTooltip />
        <Typography component='p' className={styles.controlLabel}>
          {t('aria.participants')}
        </Typography>
      </Stack>

      <Stack className={styles.controlWithLabel}>
        <ToggleSettingsButton
          disabled={isReconnecting}
          className={styles.deviceButton}
          iconClassName={styles.gearIcon}
          onClick={toggleSettings}
          withTooltip
        />
        <Typography component='p' className={styles.controlLabel}>
          {t('aria.settings')}
        </Typography>
      </Stack>
    </Stack>
  );
}
